<template>
  <b-form>
    <div class="row mb-3 border-bottom g-0">
      <div class="col-12">
        <span class="fw-bold">Catatan Dalam Penilaian</span>
      </div>
    </div>

    <div class="bg-light p-3">
      <div class="row">
        <div class="col-4 fw-bold">Temuan</div>
        <div class="col-4 fw-bold">Keterangan</div>
        <div class="col-4 fw-bold">Tindak Lanjut</div>
      </div>
      <div class="border-bottom mt-3"></div>

      <div class="row mt-3">
        <div class="col-4">
          <label>Subjek Hukum <span class="text-danger">*</span></label>
          <v-select
            id="subjek_hukum"
            v-model="form.subjek_hukum.status"
            :reduce="(data) => data.value"
            label="text"
            :options="optionSubjekHukum"
            name="Subjek Hukum"
            v-validate="'required'"
            :class="{ 'pe-none': sudah_dinilai }"
          />
          <span class="text-danger" v-if="errors.has('Subjek Hukum')">
            {{ errors.first('Subjek Hukum') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="subjek_hukum_keterangan"
            v-model="form.subjek_hukum.keterangan"
            name="Keterangan Subjek Hukum"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Keterangan Subjek Hukum')">
            {{ errors.first('Keterangan Subjek Hukum') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="subjek_hukum_tindak_lanjut"
            v-model="form.subjek_hukum.tindak_lanjut"
            name="Tindak Lanjut Subjek Hukum"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Tindak Lanjut Subjek Hukum')">
            {{ errors.first('Tindak Lanjut Subjek Hukum') }}
          </span>
        </div>
      </div>
      <div class="border-bottom mt-3"></div>

      <div class="row mt-3">
        <div class="col-4">
          <label>Perizinan {{ jenis_kegiatan }} <span class="text-danger">*</span></label>
          <v-select
            id="perizinan"
            v-model="form.perizinan.status"
            :reduce="(data) => data.value"
            label="text"
            :options="optionPerizinan"
            name="Jenis Kegiatan"
            v-validate="'required'"
            :class="{ 'pe-none': sudah_dinilai }"
          />
          <span class="text-danger" v-if="errors.has('Jenis Kegiatan')">
            {{ errors.first('Jenis Kegiatan') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="perizinan_keterangan"
            v-model="form.perizinan.keterangan"
            name="Keterangan Jenis Kegiatan"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Keterangan Jenis Kegiatan')">
            {{ errors.first('Keterangan Jenis Kegiatan') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="perizinan_tindak_lanjut"
            v-model="form.perizinan.tindak_lanjut"
            name="Tindak Lanjut Jenis Kegiatan"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Tindak Lanjut Jenis Kegiatan')">
            {{ errors.first('Tindak Lanjut Jenis Kegiatan') }}
          </span>
        </div>
      </div>
      <div class="border-bottom mt-3"></div>

      <div class="row mt-3">
        <div class="col-4">
          <label>Realisasi Luas/Panjang <span class="text-danger">*</span></label>
          <v-select
            id="realisasi_luas_panjang"
            v-model="form.realisasi_luas_panjang.status"
            :reduce="(data) => data.value"
            label="text"
            :options="optionRealisasiLuas"
            name="Realisasi Luas/Panjang"
            v-validate="'required'"
            :class="{ 'pe-none': sudah_dinilai }"
          />
          <span class="text-danger" v-if="errors.has('Realisasi Luas/Panjang')">
            {{ errors.first('Realisasi Luas/Panjang') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="realisasi_luas_panjang_keterangan"
            v-model="form.realisasi_luas_panjang.keterangan"
            name="Keterangan Realisasi Luas/Panjang"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Keterangan Realisasi Luas/Panjang')">
            {{ errors.first('Keterangan Realisasi Luas/Panjang') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="realisasi_luas_panjang_tindak_lanjut"
            v-model="form.realisasi_luas_panjang.tindak_lanjut"
            name="Tindak Lanjut Realisasi Luas/Panjang"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Tindak Lanjut Realisasi Luas/Panjang')">
            {{ errors.first('Tindak Lanjut Realisasi Luas/Panjang') }}
          </span>
        </div>
      </div>
      <div class="border-bottom mt-3"></div>

      <div class="row mt-3">
        <div class="col-4">
          <label>Realisasi Jenis Kegiatan <span class="text-danger">*</span></label>
          <v-select
            id="realisasi_jenis_kegiatan"
            v-model="form.realisasi_jenis_kegiatan.status"
            :reduce="(data) => data.value"
            label="text"
            :options="optionRealisasiKegiatan"
            name="Realisasi Jenis Kegiatan"
            v-validate="'required'"
            :class="{ 'pe-none': sudah_dinilai }"
          />
          <span class="text-danger" v-if="errors.has('Realisasi Jenis Kegiatan')">
            {{ errors.first('Realisasi Jenis Kegiatan') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="realisasi_jenis_kegiatan_keterangan"
            v-model="form.realisasi_jenis_kegiatan.keterangan"
            name="Keterangan Realisasi Jenis Kegiatan"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Keterangan Realisasi Jenis Kegiatan')">
            {{ errors.first('Keterangan Realisasi Jenis Kegiatan') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="realisasi_jenis_kegiatan_tindak_lanjut"
            v-model="form.realisasi_jenis_kegiatan.tindak_lanjut"
            name="Tindak Lanjut Realisasi Jenis Kegiatan"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Tindak Lanjut Realisasi Jenis Kegiatan')">
            {{ errors.first('Tindak Lanjut Realisasi Jenis Kegiatan') }}
          </span>
        </div>
      </div>
      <div class="border-bottom mt-3"></div>

      <div class="row mt-3">
        <div class="col-4">
          <label>Waktu Penyampaian <span class="text-danger">*</span></label>
          <b-form-input
            v-model="form.waktu_penyampaian.status"
            id="waktu_penyampaian"
            v-validate="'required'"
            name="Waktu Penyampaian"
            disabled
            style="background-color: #dddddd !important; opacity: 0.7"
          ></b-form-input>
          <!-- <v-select
            id="waktu_penyampaian"
            v-model="form.waktu_penyampaian.status"
            :reduce="(data) => data.value"
            label="text"
            :options="optionWaktuPenyampaian"
            name="Waktu Penyampaian"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('Waktu Penyampaian')">
            {{ errors.first('Waktu Penyampaian') }}
          </span> -->
        </div>
        <div class="col-4">
          <b-form-textarea
            id="waktu_penyampaian_keterangan"
            v-model="form.waktu_penyampaian.keterangan"
            name="Keterangan Waktu Penyampaian"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Keterangan Waktu Penyampaian')">
            {{ errors.first('Keterangan Waktu Penyampaian') }}
          </span>
        </div>
        <div class="col-4">
          <b-form-textarea
            id="waktu_penyampaian_tindak_lanjut"
            v-model="form.waktu_penyampaian.tindak_lanjut"
            name="Tindak Lanjut Waktu Penyampaian"
            :rows="3"
            :disabled="sudah_dinilai"
          ></b-form-textarea>
          <span class="text-danger" v-if="errors.has('Tindak Lanjut Waktu Penyampaian')">
            {{ errors.first('Tindak Lanjut Waktu Penyampaian') }}
          </span>
        </div>
      </div>

      <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import axios from 'axios'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: {
        subjek_hukum: {
          status: null,
          keterangan: null,
          tindak_lanjut: null,
        },
        perizinan: {
          status: null,
          keterangan: null,
          tindak_lanjut: null,
        },
        realisasi_luas_panjang: {
          status: null,
          keterangan: null,
          tindak_lanjut: null,
        },
        realisasi_jenis_kegiatan: {
          status: null,
          keterangan: null,
          tindak_lanjut: null,
        },
        waktu_penyampaian: {
          status: null,
          keterangan: null,
          tindak_lanjut: null,
        },
      },
      sudah_dinilai: null,
      jenis_kegiatan: null,
      optionSubjekHukum: [
        { value: 'Sesuai', text: 'Sesuai' },
        { value: 'Tidak Sesuai', text: 'Tidak Sesuai' },
      ],
      optionPerizinan: [
        { value: 'Belum Terbit', text: 'Belum Terbit' },
        { value: 'Belum Habis', text: 'Belum Habis' },
        { value: 'Sudah Habis', text: 'Sudah Habis' },
        { value: 'Tidak Dilampirkan', text: 'Tidak Dilampirkan' },
      ],
      optionRealisasiLuas: [
        { value: '> 100%', text: '> 100%' },
        { value: '<= 100%', text: '<= 100%' },
      ],
      optionRealisasiKegiatan: [
        { value: 'Sama', text: 'Sama' },
        { value: 'Berbeda', text: 'Berbeda' },
      ],
      optionWaktuPenyampaian: [
        { value: 'Tidak Terlambat', text: 'Tidak Terlambat' },
        { value: 'Terlambat', text: 'Terlambat' },
      ],
    }
  },
  mounted() {
    this.loadDataPenilaian()
  },
  methods: {
    async nextForm() {
      if (this.sudah_dinilai) {
        return true
      }

      if (await this.$validator.validateAll()) {
        this.$loading(true)
        // prettier-ignore
        const dataCatatan = {
          subjek_hukum: this.form.subjek_hukum.status,
          subjek_hukum_keterangan: this.form.subjek_hukum.keterangan,
          subjek_hukum_tindak_lanjut: this.form.subjek_hukum.tindak_lanjut,
          perizinan: this.form.perizinan.status,
          perizinan_keterangan: this.form.perizinan.keterangan,
          perizinan_tindak_lanjut: this.form.perizinan.tindak_lanjut,
          realisasi_luas: this.form.realisasi_luas_panjang.status,
          realisasi_luas_keterangan: this.form.realisasi_luas_panjang.keterangan,
          realisasi_luas_tindak_lanjut: this.form.realisasi_luas_panjang.tindak_lanjut,
          realisasi_kegiatan: this.form.realisasi_jenis_kegiatan.status,
          realisasi_kegiatan_keterangan: this.form.realisasi_jenis_kegiatan.keterangan,
          realisasi_kegiatan_tindak_lanjut: this.form.realisasi_jenis_kegiatan.tindak_lanjut,
          waktu_penyampaian: this.form.waktu_penyampaian.status,
          waktu_penyampaian_keterangan: this.form.waktu_penyampaian.keterangan,
          waktu_penyampaian_tindak_lanjut: this.form.waktu_penyampaian.tindak_lanjut,
        }

        axios.post(
          this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          { status_penilaian_laporan: 'Draft' },
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )

        return axios
          .put(this.baseapiPengendalian + `api/penilaian_laporan/${this.$route.query.id_penilaian}`, dataCatatan, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then(async (res) => {
            Swal.fire('Berhasil', 'Catatan Dalam Penilaian Laporan Tahunan tersimpan', 'success')
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        return false
      }
    },

    loadDataPenilaian() {
      if (this.$route.path.includes('tinjau')) {
        this.sudah_dinilai = true
      }

      if (!this.$route.query.id_penilaian) {
        return
      }

      axios
        .get(this.baseapiPengendalian + 'api/laporan_tahunan/' + this.$route.query.id_laporan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          this.jenis_kegiatan = res.data.data.jenis_kegiatan
        })

      axios
        .get(this.baseapiPengendalian + `api/penilaian_laporan/${this.$route.query.id_penilaian}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const data = res.data.data
          if (!data) {
            return
          }

          if (data.status === 'Selesai') {
            this.sudah_dinilai = true
          }

          this.form = {
            ...this.form,
            subjek_hukum: {
              status: data.subjek_hukum,
              keterangan: data.subjek_hukum_keterangan,
              tindak_lanjut: data.subjek_hukum_tindak_lanjut,
            },
            perizinan: {
              status: data.perizinan,
              keterangan: data.perizinan_keterangan,
              tindak_lanjut: data.perizinan_tindak_lanjut,
            },
            realisasi_luas_panjang: {
              status: data.realisasi_luas,
              keterangan: data.realisasi_luas_keterangan,
              tindak_lanjut: data.realisasi_luas_tindak_lanjut,
            },
            realisasi_jenis_kegiatan: {
              status: data.realisasi_kegiatan,
              keterangan: data.realisasi_kegiatan_keterangan,
              tindak_lanjut: data.realisasi_kegiatan_tindak_lanjut,
            },
            waktu_penyampaian: {
              status: data.status_penyampaian,
              keterangan: data.waktu_penyampaian_keterangan,
              tindak_lanjut: data.waktu_penyampaian_tindak_lanjut,
            },
          }
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data Penilaian Laporan Tahunan', 'error')
        })
    },
  },
}
</script>
